import { createPublicClient, http } from 'viem';
import { mainnet } from 'viem/chains';

const client = createPublicClient({
  chain: mainnet,
  transport: http('https://eth.llamarpc.com'),
});

export async function getENSData(address) {
  try {
    const ensName = (await client.getEnsName({ address })) ?? null; // Handle undefined
    let ensAvatar = null;

    if (ensName) {
      ensAvatar = (await client.getEnsAvatar({ name: ensName })) ?? null;
    }

    return {
      ensName,
      ensAvatar,
    };
  } catch (error) {
    console.error('Error fetching ENS data:', error);
    return {
      ensName: null,
      ensAvatar: null,
    };
  }
}
